// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('support.supportcases.changebarcodes', {
        url:'/changebarcodes',
        views: {
            'supportView@support': {
            templateUrl: 'main/support/supportcases/changebarcodes/changebarcodes.tpl.html',
            controller: 'SupportCaseChangeBarcodesController as vm'
        }},
        resolve: {
        }
    });
}

// @ngInject
function SupportCaseChangeBarcodesController($state, $scope, SupportApiService, loadSpinnerService, ToasterService, confirmationDialogService, $translate) {
    var vm = this;

    //Properties
    vm.isEditing = false;
    vm.selectedProduct = {};
    vm.selectedProductVariant = {};
    vm.selectedProductCopy = {};
    vm.selectedProductVariantCopy = {};
    vm.newBarcode = '';

    //Methods
    vm.recieveProduct = recieveProduct;
    vm.isAllowedToSave = isAllowedToSave;
    vm.startEditing = startEditing;
    vm.saveChange = saveChange;
    vm.cancelEditing = cancelEditing;
    vm.addBarcodeToProductVariant = addBarcodeToProductVariant;

    activate();

    function activate() {
    }

    function addBarcodeToProductVariant(productVariant) {
        productVariant.barcodes.push({
            barcode: '',
            id: -1
        });
    }

    function startEditing() {
        vm.isEditing = true;
    }
    function saveChange() {
        confirmationDialogService.showDialog('<div>' + $translate.instant("support.confirmUpdateData") + '</div>').then(function (result) {
            if (result === true) {
                loadSpinnerService.start("mainSpinner");

                var request = {
                    articleId: vm.selectedProductCopy.id,
                    articleVariants: []
                };
                _.forEach(vm.selectedProductCopy.productVariants, function(artVar) {
                    var requestArtVar = {
                        articleVariantId: artVar.id,
                        currentBarcode: artVar.barcode,
                        newBarcode: artVar.newBarcode.trim(),
                        barcodes: []
                    };
                    request.articleVariants.push(requestArtVar);

                    _.forEach(artVar.barcodes, function(o) {
                        o.newBarcode = o.newBarcode.trim();
                        if (o.newBarcode.length > 0) {
                            requestArtVar.barcodes.push(
                                {
                                    articleVariantId: artVar.id,
                                    id: o.id,
                                    currentBarcode: o.barcode,
                                    newBarcode: o.newBarcode
                                }
                            );
                        }
                    });
                });

                SupportApiService.changeBarcodes(request).then(function(response) {
                    cancelEditing();
                    ToasterService.showSuccess('Streckkoder uppdaterade', $translate.instant('support.supportCase'));
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, $translate.instant('common.error'));
                }).finally(function() {
                    loadSpinnerService.stop("mainSpinner");
                });
            }
        });
    }
    function cancelEditing() {
        vm.isEditing = false;
        removeProduct();
    }

    function recieveProduct(product) {
        vm.selectedProduct = product;
        loadSpinnerService.start("mainSpinner");
        SupportApiService.getProduct(vm.selectedProduct.id).then(function(response) {
            vm.selectedProduct = response;
            vm.selectedProductCopy = angular.copy(response);

            _.forEach(vm.selectedProductCopy.productVariants, function(o) {
                o.newBarcode = o.barcode;
                _.forEach(o.barcodes, function(br) {
                    br.newBarcode = br.barcode;
                });
            });

            vm.selectedProductVariant = {};
            vm.selectedProductVariantCopy = {};
        }, function(error) {
            ToasterService.showError(error.message, $translate.instant('common.error'));
        }).finally(function() {
            loadSpinnerService.stop("mainSpinner");
        });
    }
    function removeProduct() {
        vm.selectedProductCopy = {};
        vm.newBarcode = '';
        $scope.$broadcast('clearArticleEvent');
    }

    function isAllowedToSave() {
        var hasChanged = false;
        _.forEach(vm.selectedProductCopy.productVariants, function(o) {
            if (o.newBarcode !== o.barcode) {
                hasChanged = true;
            }
            _.forEach(o.barcodes, function(br) {
                if (br.newBarcode !== br.barcode) {
                    hasChanged = true;
                }
            });
        });

        return hasChanged;
    }
}

angular
    .module('supportcases.changebarcodes', ['support.api'])
    .config(stateConfig)
    .controller('SupportCaseChangeBarcodesController', SupportCaseChangeBarcodesController);
